"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewMutationTestSuiteData = exports.BugsExposedFeedbackLevel = exports.MutationTestSuite = exports.MutationTestSuiteCoreData = void 0;
var expected_student_file_1 = require("./expected_student_file");
var http_client_1 = require("./http_client");
var instructor_file_1 = require("./instructor_file");
var utils_1 = require("./utils");
var MutationTestSuiteCoreData = /** @class */ (function () {
    function MutationTestSuiteCoreData(args) {
        this.pk = args.pk;
        this.name = args.name;
        this.project = args.project;
        this.last_modified = args.last_modified;
        this.read_only_instructor_files = args.read_only_instructor_files;
        this.buggy_impl_names = args.buggy_impl_names;
        this.use_setup_command = args.use_setup_command;
        this.setup_command = args.setup_command;
        this.get_student_test_names_command = args.get_student_test_names_command;
        this.max_num_student_tests = args.max_num_student_tests;
        this.student_test_validity_check_command = args.student_test_validity_check_command;
        this.test_name_discovery_whitespace_handling = args.test_name_discovery_whitespace_handling;
        this.grade_buggy_impl_command = args.grade_buggy_impl_command;
        this.points_per_exposed_bug = args.points_per_exposed_bug;
        this.max_points = args.max_points;
        this.deferred = args.deferred;
        this.sandbox_docker_image = args.sandbox_docker_image;
        this.allow_network_access = args.allow_network_access;
        this.normal_fdbk_config = args.normal_fdbk_config;
        this.ultimate_submission_fdbk_config = args.ultimate_submission_fdbk_config;
        this.past_limit_submission_fdbk_config = args.past_limit_submission_fdbk_config;
        this.staff_viewer_fdbk_config = args.staff_viewer_fdbk_config;
    }
    return MutationTestSuiteCoreData;
}());
exports.MutationTestSuiteCoreData = MutationTestSuiteCoreData;
var MutationTestSuite = /** @class */ (function (_super) {
    __extends(MutationTestSuite, _super);
    function MutationTestSuite(args) {
        var _this = _super.call(this, args) || this;
        _this.instructor_files_needed = args.instructor_files_needed.map(function (data) { return new instructor_file_1.InstructorFile(data); });
        _this.student_files_needed = args.student_files_needed.map(function (data) { return new expected_student_file_1.ExpectedStudentFile(data); });
        return _this;
    }
    MutationTestSuite.subscribe = function (observer) {
        MutationTestSuite._subscribers.add(observer);
    };
    MutationTestSuite.unsubscribe = function (observer) {
        MutationTestSuite._subscribers.delete(observer);
    };
    MutationTestSuite.get_all_from_project = function (project_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/projects/" + project_pk + "/mutation_test_suites/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (suite_data) { return new MutationTestSuite(suite_data); })];
                }
            });
        });
    };
    MutationTestSuite.get_by_pk = function (mutation_test_suite_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/mutation_test_suites/" + mutation_test_suite_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new MutationTestSuite(response.data)];
                }
            });
        });
    };
    MutationTestSuite.create = function (project_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/projects/" + project_pk + "/mutation_test_suites/", data)];
                    case 1:
                        response = _a.sent();
                        result = new MutationTestSuite(response.data);
                        MutationTestSuite.notify_mutation_test_suite_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    MutationTestSuite.notify_mutation_test_suite_created = function (mutation_test_suite) {
        var e_1, _a;
        try {
            for (var _b = __values(MutationTestSuite._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_mutation_test_suite_created(mutation_test_suite);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    MutationTestSuite.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/mutation_test_suites/" + this.pk + "/", utils_1.filter_keys(this, MutationTestSuite.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new MutationTestSuite(response.data));
                        MutationTestSuite.notify_mutation_test_suite_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    MutationTestSuite.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, reloaded;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, MutationTestSuite.get_by_pk(this.pk)];
                    case 1:
                        reloaded = _a.sent();
                        utils_1.safe_assign(this, reloaded);
                        if (last_modified !== this.last_modified) {
                            MutationTestSuite.notify_mutation_test_suite_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MutationTestSuite.notify_mutation_test_suite_changed = function (mutation_test_suite) {
        var e_2, _a;
        try {
            for (var _b = __values(MutationTestSuite._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_mutation_test_suite_changed(mutation_test_suite);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    MutationTestSuite.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/mutation_test_suites/" + this.pk + "/")];
                    case 1:
                        _a.sent();
                        MutationTestSuite.notify_mutation_test_suite_deleted(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    MutationTestSuite.notify_mutation_test_suite_deleted = function (mutation_test_suite) {
        var e_3, _a;
        try {
            for (var _b = __values(MutationTestSuite._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_mutation_test_suite_deleted(mutation_test_suite);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    MutationTestSuite.get_order = function (project_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/projects/" + project_pk + "/mutation_test_suites/order/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    MutationTestSuite.update_order = function (project_pk, ag_test_suite_order) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/projects/" + project_pk + "/mutation_test_suites/order/", ag_test_suite_order)];
                    case 1:
                        response = _a.sent();
                        MutationTestSuite.notify_mutation_test_suite_order_updated(project_pk, response.data);
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    MutationTestSuite.notify_mutation_test_suite_order_updated = function (project_pk, mutation_test_suite_order) {
        var e_4, _a;
        try {
            for (var _b = __values(MutationTestSuite._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_mutation_test_suites_order_changed(project_pk, mutation_test_suite_order);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    MutationTestSuite._subscribers = new Set();
    MutationTestSuite.EDITABLE_FIELDS = [
        'name',
        'instructor_files_needed',
        'read_only_instructor_files',
        'student_files_needed',
        'buggy_impl_names',
        'use_setup_command',
        'setup_command',
        'get_student_test_names_command',
        'max_num_student_tests',
        'student_test_validity_check_command',
        'test_name_discovery_whitespace_handling',
        'grade_buggy_impl_command',
        'points_per_exposed_bug',
        'max_points',
        'deferred',
        'sandbox_docker_image',
        'allow_network_access',
        'normal_fdbk_config',
        'ultimate_submission_fdbk_config',
        'past_limit_submission_fdbk_config',
        'staff_viewer_fdbk_config',
    ];
    return MutationTestSuite;
}(MutationTestSuiteCoreData));
exports.MutationTestSuite = MutationTestSuite;
var BugsExposedFeedbackLevel;
(function (BugsExposedFeedbackLevel) {
    BugsExposedFeedbackLevel["no_feedback"] = "no_feedback";
    BugsExposedFeedbackLevel["num_bugs_exposed"] = "num_bugs_exposed";
    BugsExposedFeedbackLevel["exposed_bug_names"] = "exposed_bug_names";
    BugsExposedFeedbackLevel["all_bug_names"] = "all_bug_names";
})(BugsExposedFeedbackLevel = exports.BugsExposedFeedbackLevel || (exports.BugsExposedFeedbackLevel = {}));
var NewMutationTestSuiteData = /** @class */ (function () {
    function NewMutationTestSuiteData(args) {
        this.name = args.name;
        this.instructor_files_needed = args.instructor_files_needed;
        this.student_files_needed = args.student_files_needed;
        this.read_only_instructor_files = args.read_only_instructor_files;
        this.buggy_impl_names = args.buggy_impl_names;
        this.use_setup_command = args.use_setup_command;
        this.setup_command = args.setup_command;
        this.get_student_test_names_command = args.get_student_test_names_command;
        this.max_num_student_tests = args.max_num_student_tests;
        this.student_test_validity_check_command = args.student_test_validity_check_command;
        this.grade_buggy_impl_command = args.grade_buggy_impl_command;
        this.points_per_exposed_bug = args.points_per_exposed_bug;
        this.max_points = args.max_points;
        this.deferred = args.deferred;
        this.sandbox_docker_image = args.sandbox_docker_image;
        this.allow_network_access = args.allow_network_access;
        this.normal_fdbk_config = args.normal_fdbk_config;
        this.ultimate_submission_fdbk_config = args.ultimate_submission_fdbk_config;
        this.past_limit_submission_fdbk_config = args.past_limit_submission_fdbk_config;
        this.staff_viewer_fdbk_config = args.staff_viewer_fdbk_config;
    }
    return NewMutationTestSuiteData;
}());
exports.NewMutationTestSuiteData = NewMutationTestSuiteData;
//# sourceMappingURL=mutation_test_suite.js.map